import React, { useState, useEffect } from 'react';
import { Input, Button, Card, Typography, message } from 'antd';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

const { Title } = Typography;

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // ✅ récupère l'ID depuis l'URL OU localStorage
  const userId = searchParams.get('id') || localStorage.getItem('resetUserId');

  useEffect(() => {
    if (!userId) {
      message.error("Identifiant utilisateur introuvable. Veuillez réactiver votre compte.");
      navigate('/login');
    }
  }, [userId, navigate]);

  const handleReset = async () => {
    if (!newPassword || !repeatPassword) {
      return message.warning("Veuillez remplir les deux champs.");
    }
    if (newPassword !== repeatPassword) {
      return message.error("Les mots de passe ne correspondent pas.");
    }

    setLoading(true);
    try {
      await axios.post("http://localhost:8080/public/rest/reset-password", {
        id: userId,
        password: newPassword
      });
      message.success("Mot de passe modifié avec succès !");
      localStorage.removeItem("resetUserId"); // ✅ au cas où l'ID venait du localStorage
      navigate("/login");
    } catch (err) {
      console.error(err);
      message.error("Erreur lors de la mise à jour.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f5f5f5",
      padding: "1rem"
    }}>
      <Card style={{ width: 400 }}>
        <Title level={3}>🔐 Modifier mon mot de passe</Title>
        <Input.Password
          placeholder="Nouveau mot de passe"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          style={{ marginBottom: "1rem" }}
        />
        <Input.Password
          placeholder="Répéter le mot de passe"
          value={repeatPassword}
          onChange={e => setRepeatPassword(e.target.value)}
          style={{ marginBottom: "1rem" }}
        />
        <Button
          type="primary"
          block
          loading={loading}
          onClick={handleReset}
        >
          Valider
        </Button>
      </Card>
    </div>
  );
};

export default ResetPassword;
